module.exports = __webpack_public_path__ + "img/TV_Adverts_3_Background.260f23d6.jpg";